export default "__VITE_ASSET__BYpjPKGP__"